import React, { useState } from 'react';
import selectors from 'state/selectors';
import utils from 'utils';
import { useAsync } from 'react-use';
import { Header, Content, Footer } from 'components/Modal';
import LoadingBar from 'components/BarLoader';
import { useSelector } from 'react-redux';
import services from 'services';
import styled from 'styled-components/macro';

const LoadingBarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 4px;
`;

const LoadingErrors = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);
  const [loader, setLoader] = useState<number | undefined>(undefined);

  useAsync(async () => {
    if (modalProps?.selectedErrors?.length > 0) {
      try {
        const numberOfErrors = 100 / modalProps.selectedErrors.length;
        for (const protocol of modalProps.selectedErrors) {
          await services.retryErrors([protocol]);
          setLoader((prev) => {
            if (prev !== undefined) {
              return prev + numberOfErrors;
            }
            return 0 + numberOfErrors;
          });
        }
      } catch (e) {
        utils.app.notify('fail', t('not_success_retry'));
        console.error(e);
      } finally {
        setLoader(100);
        // Refresh cache using the callback passed from parent
        if (modalProps?.refresh) {
          modalProps.refresh();
        }
        utils.app.notify('success', t('success_retry'));
      }
    }
  }, []);

  return (
    <>
      <Header title={''} />
      <Content>
        <LoadingBarContainer>
          <LoadingBar currentPercentage={loader ?? 0} />
          <span>{Math.floor(loader ?? 0)}%</span>
        </LoadingBarContainer>
      </Content>
      <Footer closeButtonText={t('close')} withCloseButton closeDisabled={loader !== 100} withConfirmButton={false} />
    </>
  );
};

export { LoadingErrors };
